import * as React from 'react';
import { TouchableOpacity } from 'react-native';
import { rem } from 'design-system/values';
import { EmojiPickerModalContent } from 'design-system/emojiPicker/EmojiPickerModal';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { webPickerWidth } from 'features/emoji-picker/components/EmojiSelector';
const WebEmojiPicker = ({ fx, fy, defaultSelectedEmoji, onEmojiSelected, clearWebEmojiPickerState, }) => {
    const styles = useStyles(styleSet);
    if (fx && fy) {
        return (<TouchableOpacity activeOpacity={1} style={styles.container} onPress={clearWebEmojiPickerState}>
        <TouchableOpacity activeOpacity={1} style={[styles.innerContainer, { left: fx, top: fy }]}>
          <EmojiPickerModalContent onEmojiSelected={onEmojiSelected} defaultSelectedEmoji={defaultSelectedEmoji}/>
        </TouchableOpacity>
      </TouchableOpacity>);
    }
    return undefined;
};
export default React.memo(WebEmojiPicker);
const styleSet = createStyleSheets((colors) => ({
    container: {
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        bottom: 0,
        position: 'absolute',
    },
    innerContainer: {
        cursor: 'auto',
        width: webPickerWidth,
        paddingTop: rem(8),
        borderWidth: rem(1),
        borderRadius: rem(14),
        paddingBottom: rem(16),
        borderColor: colors.borders.divider,
        backgroundColor: colors.background.light,
        ...colors.shadows.webFloatingCard,
    },
}));
